// https://vuex.vuejs.org/en/state.html

export default {
  countries: [],
  pollingEntities: [],
  loadingMessages: [],
  supportInfo: '',
  activityLog: [],
  unreadNotifications: [],
}
